import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActividadModel, EstrategiaModel } from 'src/app/model/PlanGestionConvivencia.model';
import { PlanGestionConvivenciaComponent } from '../../plan-gestion-convivencia.component';

@Component({
  selector: 'app-estrategia-pgc',
  templateUrl: './estrategia-pgc.component.html',
  styleUrls: ['./estrategia-pgc.component.css']
})
export class EstrategiaPgcComponent implements OnInit {

  @Input() estrategia : EstrategiaModel;
  @Input() index : number;
  @Input() readonly : boolean;
  public isCollapsed = true;

  constructor(
    @Inject(PlanGestionConvivenciaComponent) private parent: PlanGestionConvivenciaComponent
  ) { }

  ngOnInit(): void {
  }

  agregarActividad(){
    this.parent.spinner.show();
    if( this.estrategia.actividades.length <= 4 ){
      this.estrategia.actividades.push(new ActividadModel());
    }
    this.parent.spinner.hide();
  }

  eliminarEstrategia(largo:number){

    if( this.parent.planGestionConvivenciaModel.estrategias.length > 3 ){
      this.parent.planGestionConvivenciaModel.estrategias.splice(largo,1);
    }
  }

}
